import { mutate } from 'swr';
import { Organization } from '../../../types/organization';

export const mutateUserProfileData = (organization: Organization, externalUserProfileId: string) => {
  mutate(`/organizations/${organization.id}/external-users/${externalUserProfileId}`);
  mutate(`/organizations/${organization?.id}/reservations?externalUserId=${externalUserProfileId}`);
  mutate(`/organizations/${organization.id}/external-users/${externalUserProfileId}/expenses`);
};
